// extracted by mini-css-extract-plugin
export default {"parent":"Portfolio_parent__zLyhB","outerContainer":"Portfolio_outerContainer__NGK8Q","base":"Portfolio_base__mzykm"};